import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=3561fde1&"
import script from "./adv.vue?vue&type=script&lang=js&"
export * from "./adv.vue?vue&type=script&lang=js&"
import style0 from "./adv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports